import { Avatar } from "react-rainbow-components";
import styled from "styled-components";

const AvatarImage = styled(Avatar)`
  width: 3rem !important;
  height: 3rem !important;
  border-radius: 2rem;
  ${({ scaleImage }: { scaleImage?: number }) =>
    scaleImage && `transform: scale(${scaleImage});`}
`;
const ContainerProfile = styled.div`
  display: flex;
  min-width: 330px;
  align-items: center;
  text-overflow: ellipsis;
`;

const FullName = styled.h4`
  margin: 0;
  color: #123559;
  font-size: 1rem;
  ${({ isLightText }: { isLightText: boolean | undefined }) =>
    isLightText && "color: #FFF;"}
`;

const LineId = styled.p`
  margin: 0;
  color: #123559;
  font-size: 0.75rem;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ isLightText }: { isLightText: boolean | undefined }) =>
    isLightText && "color: #FFF;"}
`;
interface IProfileProps {
  avatar: string;
  name: string;
  lineId?: string;
  isLightText?: boolean;
  styleImader?: React.CSSProperties;
  style?: React.CSSProperties;
  styleLineId?: React.CSSProperties;
}
export const ProfileComponent = (props: IProfileProps) => {
  const styles = props.style ? props.style : {};
  const styleLineId = props.styleLineId ? props.styleLineId : {};
  return (
    <ContainerProfile style={{ display: "flex", ...styles }}>
      <div style={{ width: "3rem", margin: "0 1rem" }}>
        <AvatarImage
          src={props.avatar}
          title={props.name}
          assistiveText={props.name}
          initials={props.name}
        />
      </div>
      <div>
        <FullName isLightText={props.isLightText}>{props.name}</FullName>
        {props.lineId && (
          <LineId isLightText={props.isLightText} style={{ ...styleLineId }}>
            {props.lineId}
          </LineId>
        )}
      </div>
    </ContainerProfile>
  );
};
